/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import isEqual from 'react-fast-compare';
import _ from 'underscore';

import * as util from 'biojs/Util';
import {CRISPRAnalysisSequenceAttributes, CRISPRRegion} from 'constants/CRISPRConstants';
import {Genome} from 'constants/GenomeConstants';
import CRISPRAnalysisActions from 'molbio/crispr/CRISPRAnalysisActions';
import GenomeRegionLabel from 'molbio/crispr/GenomeRegionLabel';
import * as sequtil from 'molbio/SeqUtil';
import notifications from 'notifications';
import getTestProps from 'test/lib/cypress/getTestProps';
import Col from 'ui-library/bs/Col';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import {BLUE} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import IndeterminateCheckbox from 'ui-library/IndeterminateCheckbox';
import {Optional} from 'util/Types';

const MAX_REGION_LENGTH = 5000;
const MAX_TOTAL_REGION_LENGTH = 30000;

interface Props {
  allowEdits: boolean;
  analysisId: string;
  annotations: Array<{
    start: number;
    end: number;
    name: string;
  }>;
  findGuidesParams: any;
  regionLoading: boolean;
  regions: Array<CRISPRRegion>;
  selectedRegions: {[regionId: string]: boolean};
  selection: {
    start?: number;
    end?: number | null;
  };
  sequence: CRISPRAnalysisSequenceAttributes;
  setSelection: (start: number, end: number) => void;
  genome: Genome;
}

interface State {
  editRegionId: string | null;
  start: Optional<number> | string;
  end: Optional<number> | string;
}

export default class CRISPRRegionTable extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    let {start, end}: {start?: Optional<number>; end?: Optional<number>} = props.selection;
    const {length, startIndex} = props.sequence;
    [start, end] = Array.from(sequtil.modelRangeToDisplay(start, end, length, startIndex));

    this.state = {
      editRegionId: null,
      start: end != null ? start : undefined,
      end,
    };
  }

  regionStartInputRef = React.createRef<HTMLInputElement>();

  override UNSAFE_componentWillReceiveProps(nextProps: Props): void {
    let {start, end}: {start?: Optional<number>; end?: Optional<number>} = nextProps.selection;
    if (!isEqual(this.props.selection, nextProps.selection) && start != null && end != null) {
      const {length, startIndex} = this.props.sequence;
      [start, end] = Array.from(sequtil.modelRangeToDisplay(start, end, length, startIndex));
      this.setState({start, end});
    }
  }

  submit = (e: any): void => {
    e.preventDefault();
    if (Number.isNaN(this.state.start) || Number.isNaN(this.state.end)) {
      notifications.error('Enter a valid start and end position or select it in the sequence map.');
      return;
    }
    const start = sequtil.displayStartToModel(
      Number.parseInt(this.state.start as string, 10),
      this.props.sequence.startIndex
    );
    const end = sequtil.displayEndToModel(
      Number.parseInt(this.state.end as string, 10),
      this.props.sequence.length,
      this.props.sequence.startIndex
    );
    if (!sequtil.doesRangeInclude(0, this.props.sequence.length, [start, end])) {
      notifications.error('Enter a valid start and end position or select it in the sequence map.');
      return;
    }
    const regionLength = sequtil.length(start, end, this.props.sequence.length);
    if (regionLength > MAX_REGION_LENGTH) {
      notifications.error(`Target region cannot exceed ${MAX_REGION_LENGTH} bp - please try a smaller \
region.`);
      return;
    }
    let totalRegionLength = regionLength;
    for (const region of Array.from(this.props.regions)) {
      if (region.id !== this.state.editRegionId) {
        // edit region has already been counted
        totalRegionLength += sequtil.length(region.start, region.end, this.props.sequence.length);
      }
    }
    if (totalRegionLength > MAX_TOTAL_REGION_LENGTH) {
      notifications.error(`Target regions cannot exceed ${MAX_TOTAL_REGION_LENGTH} bp combined - please try \
smaller regions.`);
      return;
    }
    const data = {start, end};
    if (this.state.editRegionId != null) {
      CRISPRAnalysisActions.updateRegion(
        this.props.analysisId,
        this.state.editRegionId,
        data,
        this.props.findGuidesParams
      );
      this.setState({editRegionId: null});
    } else {
      CRISPRAnalysisActions.createRegion(this.props.analysisId, data, this.props.findGuidesParams);
    }
  };

  isRegionSelected = (region: CRISPRRegion): boolean => this.props.selectedRegions[region.id] || false;

  getRegionBases = (region: CRISPRRegion): string =>
    util.slice(this.props.sequence.bases, region.start, region.end, this.props.sequence.circular);

  selectRows = (regions: any, e: any): void => {
    CRISPRAnalysisActions.toggleSelectedRegions(
      this.props.analysisId,
      // eslint-disable-next-line no-restricted-syntax
      _.pluck(regions, 'id'),
      e.target.checked
    );
  };

  editRegion = (region: CRISPRRegion): void => {
    const state = {
      editRegionId: region.id,
      start: sequtil.modelStartToDisplay(region.start, this.props.sequence.startIndex),
      end: sequtil.modelEndToDisplay(region.end, this.props.sequence.length, this.props.sequence.startIndex),
    };
    this.setState(state, () => {
      this.regionStartInputRef.current!.select();
    });
  };

  deleteRegion = (region: CRISPRRegion): void => {
    CRISPRAnalysisActions.deleteRegion(this.props.analysisId, region.id);
    if (this.state.editRegionId === region.id) {
      this.setState({editRegionId: null});
    }
  };

  updateRegion = (regionId: string, region: CRISPRRegion): void => {
    CRISPRAnalysisActions.updateRegion(this.props.analysisId, regionId, region, this.props.findGuidesParams);
  };

  regionClickHandler = (region: CRISPRRegion, e: any): void => {
    if (!$(e.target).is('td')) {
      return;
    }
    this.props.setSelection(region.start, region.end);
  };

  override render(): JSX.Element {
    const sortedRegions = _.sortBy(this.props.regions, 'start');
    return (
      <div {...getTestProps({component: 'CRISPRRegionTable', element: 'root'})}>
        {sortedRegions.length === 0 ? (
          this.props.allowEdits ? (
            <div className="alert alert-info">
              {'To get started, create a '}
              <strong>target region</strong>
              {' by selecting it on the sequence map and pressing '}
              <BenchlingIcon icon="plus-large" />
              {'\u2009.'}
            </div>
          ) : (
            <div className="alert alert-info">No target regions have been created.</div>
          )
        ) : undefined}
        <form onSubmit={this.submit}>
          <Row className="u-small-spacing-top">
            <Col className="text-right" sm={3}>
              <Label className="u-input-line-height">Target region</Label>
            </Col>
            <Col sm={3}>
              <input
                type="text"
                placeholder="Start"
                // @ts-expect-error: TS does not like the possibility of null here
                value={this.state.start}
                onChange={(e) => {
                  this.setState({start: e.target.value});
                }}
                ref={this.regionStartInputRef}
                disabled={!this.props.allowEdits}
                {...getTestProps({component: 'CRISPRRegionTable', element: 'regionStartInput'})}
              />
            </Col>
            <Col sm={3}>
              <input
                type="text"
                placeholder="End"
                // @ts-expect-error: TS does not like the possibility of null here
                value={this.state.end}
                onChange={(e) => {
                  this.setState({end: e.target.value});
                }}
                disabled={!this.props.allowEdits}
                {...getTestProps({component: 'CRISPRRegionTable', element: 'regionEndInput'})}
              />
            </Col>
            <Col sm={3}>
              <Tooltip
                title={this.state.editRegionId != null ? 'Update' : 'Create'}
                container="body"
                placement={TooltipPlacement.BOTTOM}
              >
                <button
                  className="button button--small button--primary"
                  type="submit"
                  disabled={this.props.regionLoading || !this.props.allowEdits}
                  {...getTestProps({component: 'CRISPRRegionTable', element: 'createButton'})}
                >
                  <BenchlingIcon icon={this.state.editRegionId != null ? 'refresh' : 'plus-large'} />
                </button>
              </Tooltip>
              {this.state.editRegionId != null ? (
                <Tooltip title="Cancel Update" container="body" placement={TooltipPlacement.BOTTOM}>
                  <a
                    className="faded u-input-line-height u-primary-pointer u-small-spacing-left"
                    onClick={() => {
                      this.setState({editRegionId: null});
                    }}
                  >
                    <BenchlingIcon icon="xmark-large" />
                  </a>
                </Tooltip>
              ) : null}
            </Col>
          </Row>
        </form>
        {sortedRegions.length > 0 ? (
          <table className="table u-small-spacing-top">
            <thead>
              <tr>
                <th>
                  <IndeterminateCheckbox
                    items={sortedRegions}
                    selectedMap={this.isRegionSelected}
                    onChange={this.selectRows.bind(null, sortedRegions)}
                  />
                </th>
                <th className="text-center">Start</th>
                <th className="text-center">End</th>
                <th>Annotations</th>
                <th style={{minWidth: 150}}>Genome Region</th>
                <th style={{minWidth: 50}} />
              </tr>
            </thead>
            <tbody>
              {(() => {
                const result = [];
                // eslint-disable-next-line no-var, vars-on-top
                for (var region of Array.from(sortedRegions)) {
                  const annotations = _.chain(this.props.annotations)
                    // eslint-disable-next-line no-loop-func
                    .filter(({start, end}) => sequtil.isRangeWithin(start, end, region.start, region.end))
                    .sortBy(({start, end}) => -sequtil.length(start, end, this.props.sequence.length))
                    .value();
                  const annotationNames = annotations.slice(0, 3).map(({name}) => name);
                  if (annotations.length > 3) {
                    annotationNames[2] += '...';
                  }

                  result.push(
                    <tr
                      key={region.id}
                      className={classNames({
                        active: this.state.editRegionId === region.id,
                        'u-pointer': true,
                      })}
                      onClick={this.regionClickHandler.bind(null, region)}
                    >
                      <td>
                        <input
                          type="checkbox"
                          className={css(styles.checkbox)}
                          checked={this.isRegionSelected(region)}
                          onChange={this.selectRows.bind(null, [region])}
                        />
                      </td>
                      <td
                        className="text-center"
                        {...getTestProps({component: 'CRISPRRegionTable', element: 'tableRowStartCell'})}
                      >
                        {sequtil.modelStartToDisplay(region.start, this.props.sequence.startIndex)}
                      </td>
                      <td className="text-center">
                        {sequtil.modelEndToDisplay(
                          region.end,
                          this.props.sequence.length,
                          this.props.sequence.startIndex
                        )}
                      </td>
                      <td>{annotationNames.join(', ')}</td>
                      <td style={{whiteSpace: 'nowrap'}}>
                        <GenomeRegionLabel
                          allowEdits={this.props.allowEdits}
                          genome={this.props.genome}
                          getRegionBases={this.getRegionBases}
                          region={region}
                          updateRegion={this.updateRegion}
                        />
                      </td>
                      <td>
                        {this.props.allowEdits
                          ? [
                              <a
                                key="edit"
                                className="faded u-primary-pointer u-small-spacing-right"
                                onClick={this.editRegion.bind(null, region)}
                              >
                                <BenchlingIcon icon="edit" />
                              </a>,
                              <a
                                key="delete"
                                className="faded u-danger-pointer"
                                onClick={this.deleteRegion.bind(null, region)}
                              >
                                <BenchlingIcon icon="trash-can" />
                              </a>,
                            ]
                          : undefined}
                      </td>
                    </tr>
                  );
                }
                return result;
              })()}
            </tbody>
          </table>
        ) : undefined}
      </div>
    );
  }
}

const styles = StyleSheet.create({
  checkbox: {
    accentColor: BLUE,
  },
});
